import {
  OreIconButton,
  OrePill,
  OreTableCell,
  OreTableRow,
  OreText,
  OreTooltip,
  OreStack,
  SvgBin,
  SvgEdit,
  OreModal,
  OreModalBox,
  OreModalBoxBody,
  OreModalBoxFooter,
  SvgClose,
  OreHeading,
  OreButton,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { AccessRolesModel, OrePillTones } from '@/AccessRoles/domain'
import { accessRolesTranslation } from '../AccesRolesTranslation'
import { OreModalCreateProfile } from '@/partnersGroups/ui/organisms/OreModalCreateProfile'
import { Dispatch, SetStateAction, useState } from 'react'
import { useUserData } from '@/User/ui/context'
import { GroupType } from '@/partnersGroups/domain/ProfileTypes'

interface Props {
  profile: AccessRolesModel
  setRefresh: Dispatch<SetStateAction<number>>
  groupType: GroupType
}

export const AccessRolesRow = ({
  profile,
  setRefresh,
  groupType
}: Props): JSX.Element => {
  const { deleteProfile } = useUserData();
  const { t } = useTranslation()
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const handleOnClose = () => {
      setOpen(false);
      setRefresh(r => r + 1); // Incrementa para forzar la reinstanciación
  };
  const fullName =
    profile.name +
    ' ' +
    profile.surname +
    ' ' +
    (profile.surname2 ? profile.surname2 : '')
  return (
    <>
      <OreTableRow valign="middle">
        <OreTableCell align="left" as="td" size="auto">
          <OreText bold size="text-sm" tone="neutral-900">
            {fullName}
          </OreText>
        </OreTableCell>
        <OreTableCell align="left" as="td" size="auto">
          {profile.email}
        </OreTableCell>
        <OreTableCell align="left" as="td" size="auto">
          {profile.enabled ? (
            <OrePill tone={OrePillTones.success}>
              {t(accessRolesTranslation.table.statusActive)}
            </OrePill>
          ) : (
            <OrePill tone={OrePillTones.warning}>
              {t(accessRolesTranslation.table.statusPending)}
            </OrePill>
          )}
        </OreTableCell>
        <OreTableCell align="left" as="td" size="auto">
          {profile.rolName}
        </OreTableCell>
        <OreTableCell align="left" as="td" size="auto">
          <OreStack direction='row'>
            <OreTooltip
              text={t(accessRolesTranslation.table.deleteProfile)}
              placement="top"
              separation="small">
              <OreIconButton
                icon={<SvgBin />}
                onClick={() => setOpenDelete(true)}
              />
            </OreTooltip>
            <OreTooltip
              text={t(accessRolesTranslation.table.editProfile)}
              placement="top"
              separation="small">
              <OreIconButton
                icon={<SvgEdit />}
                onClick={() => setOpen(true)}
              />
            </OreTooltip>
          </OreStack>
        </OreTableCell>
      </OreTableRow>
      <OreModalCreateProfile
          open={open}
          onClose={handleOnClose}
          mode="edit"
          profileData={profile}
          groupType={groupType}
      />
      <OreModal open={openDelete} handleOnClose={() => setOpenDelete(false)}>
        <OreModalBox
          handleOnClose={() => setOpenDelete(false)}
          closeIcon={false}>
          <OreModalBoxBody>
            <OreHeading size="headline-md">
              {t(accessRolesTranslation.modal.delete.title)}
            </OreHeading>
            <OreText>
              {t(accessRolesTranslation.modal.delete.desc)}
            </OreText>
          </OreModalBoxBody>
            <OreModalBoxFooter>
              <OreStack direction="row" space="medium" placeContent="end">
                <OreButton
                  as="button"
                  category="secondary"
                  size="small"
                  onClick={() => setOpenDelete(false)}>
                  {t(accessRolesTranslation.modal.delete.cancel)}
                </OreButton>
                <OreButton
                  as="button"
                  category="danger"
                  size="small"
                  onClick={() => deleteProfile(profile.userName).then(() => {
                    setOpenDelete(false)
                    setRefresh(r => r + 1);
                  })}>
                  {t(accessRolesTranslation.modal.delete.delete)}
                </OreButton>
              </OreStack>
            </OreModalBoxFooter>
        </OreModalBox>
      </OreModal>
    </>
  )
}
